// src/config/authConfig.js
import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "e2c8a873-87ac-47f5-9fef-eb3cc381e8e4",
    authority: "https://login.microsoftonline.com/organizations",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
  prompt: "select_account",
};

// Polyfill básico para entornos de desarrollo HTTP (*.test) donde el navegador deshabilita crypto.subtle
if (typeof window !== "undefined" && window.crypto && !window.crypto.subtle) {
  window.crypto.subtle = {
    digest: async () => new Uint8Array(32),
    importKey: async () => ({}),
    exportKey: async () => new ArrayBuffer(0),
    sign: async () => new ArrayBuffer(0),
    verify: async () => true,
    generateKey: async () => ({}),
    encrypt: async () => new ArrayBuffer(0),
    decrypt: async () => new ArrayBuffer(0),
  };
}

// Instancia única para toda la app con captura de errores para entornos no seguros
let instance = null;
try {
  instance = new PublicClientApplication(msalConfig);
} catch (error) {
  console.warn("⚠️ MSAL (Inicio con Microsoft) requiere HTTPS o localhost:", error.message);
  instance = {
    initialize: async () => {},
    handleRedirectPromise: async () => null,
    loginPopup: async () => { throw new Error("Inicio con Microsoft requiere HTTPS o localhost."); },
    acquireTokenSilent: async () => { throw new Error("No disponible"); },
    getAllAccounts: () => [],
    getActiveAccount: () => null,
    setActiveAccount: () => {},
    addEventCallback: () => null,
    removeEventCallback: () => {},
    enableAccountStorageEvents: () => {},
    disableAccountStorageEvents: () => {},
  };
}

export const msalInstance = instance;

